import Core from 'core/js/pages/nearests-stops/index.js'
import TopologyStopsService from 'js/services/api/topology/stops.js'
import DetailsRouteValenbici from 'js/components/details-route-valenbici'
import BikeLogo from 'assets/images/valenbisiLogoModal.svg'
import {aggregateStopsByZoom} from '../../lib/map/aggregate-stops-by-zoom'
import template from './index.pug'

const BIKE = 'bike'
const BIKE_ROUTE_ID = '111111'

// @vue/component
export default Vue.extend({
  name: 'nearest-stops-page-custom-vl',
  template: template(),

  components: {
    DetailsRouteValenbici
  },

  extends: Core,

  data() {
    return {
      bikeStops: [],
      directionsStopsBike: '',
      bikesAvailable: 0,
      spacesAvailableBike: 0,
      tooltipPosition: {
        x: 0,
        y: 0
      },
      tooltipVisible: false,
      bikeStopsToAdd: [],
      latStopBike: null,
      lonStopBike: null
    }
  },

  watch: {
    pointerPosition: {
      handler() {
        if(!this.selectedStop.id){
          this.hideTooltip()
        }
      }
    }
  },

  methods: {
    getVisibleStopsByMapAndZoom(inputStops = this.filteredStops) {
      const stops = Array.isArray(inputStops) ? inputStops : []
      if (!stops.length) return stops

      let visibleStops = stops
      if (this?.map?.getBounds) {
        const bounds = this.map.getBounds()
        visibleStops = stops.filter(stop => {
          const lat = Number(stop.lat)
          const lng = Number(stop.lng)
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false

          return bounds.contains([lat, lng])
        })
      }

      return aggregateStopsByZoom(visibleStops, {
        map: this.map,
        zoom: this.map?.getZoom ? this.map.getZoom() : this.zoom,
        selectedStop: this.selectedStop,
        selectedStopCandidates: stops
      })
    },

    async loadTenantData() {
      await this.getBikes()
      this.addValnbiciToOperator()
    },

    async processSpecialStops() {
      this.processBikeStops()
    },

    async getBikes() {
      try {
        const response = await TopologyStopsService.bikes(this.currentAppConfig.id)
        const isOpentripplanner = this.currentAppConfig.planner_motor === 'opentripplanner'
        const isNotBlank = this.currentAppConfig.planner_motor_url !== ''
        if(isOpentripplanner && isNotBlank){
          this.bikeStops = response.stations
        }else{
          this.bikeStops = []
        }
      } catch {
        this.bikeStops = []
      }
    },

    addValnbiciToOperator() {
      if(this.bikeStops.length > 0){
        this.operators.push({
          route_ids: [BIKE_ROUTE_ID],
          id: BIKE,
          operator_type: BIKE,
          name: 'Valenbisi',
          business_name: 'Valenbisi',
          selected: true,
          img_url: {url: BikeLogo},
          logo_url: {url: BikeLogo}
        })
      }
    },

    processBikeStops() {
      if(!this.map){
        return
      }

      this.bikeStopsToAdd = []

      const operators = Array.isArray(this.operators) ? this.operators : []
      if(operators.some(op => op.id === BIKE && op.selected)){
        this.bikeStopsToAdd = this.bikeStops
          .map(bikeStop => ({
            route_ids: [BIKE_ROUTE_ID],
            id: bikeStop.id,
            operator_type: BIKE,
            name: this.formatName(bikeStop.name),
            lat: bikeStop.y,
            lng: bikeStop.x,
            img_url: BikeLogo,
            logo_url: BikeLogo,
            bikesAvailable: bikeStop.bikesAvailable,
            spacesAvailable: bikeStop.spacesAvailable,
            distance: this.map.distance(
              [this.pointerPosition.lat, this.pointerPosition.lng],
              [bikeStop.y, bikeStop.x]
            )
          }))
          .filter(stop => stop.distance <= this.distance)
      }

      if(this.bikeStopsToAdd.length > 0){
        this.stops = [...this.stops, ...this.bikeStopsToAdd]
      }

      // Enrich stops with operator metadata; filtering is handled later by applyOperators().
      this.stops = this.filterStopsByOperatorRoutes()
    },

    isValenbiciOperator(type) {
      return type === BIKE
    },

    formatName(name) {
      return name
        .replaceAll('_', ' ')
        .toLowerCase()
        .replaceAll(/\b\w/g, c => c.toUpperCase())
    },

    beforeShowStop() {
      this.hideTooltip()
    },

    onStopSelected(stop) {
      if(stop.operator_type === BIKE){
        this.showTooltip(stop)
      }
    },

    onStopHidden() {
      this.hideTooltip()
    },

    showTooltip(stop) {
      const markerCoordinates = this.map.latLngToContainerPoint([stop.lat, stop.lng])

      this.tooltipPosition = {
        x: markerCoordinates.x,
        y: markerCoordinates.y
      }

      this.directionsStopsBike = stop.name
      this.bikesAvailable = stop.bikesAvailable
      this.spacesAvailableBike = stop.spacesAvailable
      this.latStopBike = stop.lat
      this.lonStopBike = stop.lng
      this.tooltipVisible = true
    },

    hideTooltip() {
      this.tooltipVisible = false
    }
  }
})
